import * as React from 'react';

import './AccountCard.scss';

export default function Account(props: IAccountProps) {
  const activeClass = props.isActive ? 'active' : '';
  return (
    <div
      className={`account-switch--accounts--account ${activeClass}`}
      onClick={props.action}
    >
      <div className="icon">
        <i className="rpds-user" />
      </div>
      <div className="account-detail">
        <p className="account-id">
          #{props.accountId}
          <small>{props.userId ? ` (${props.userId})` : ''}</small>
        </p>
        <p className="account-name">{props.accountName}</p>
      </div>
    </div>
  );
}

interface IAccountProps {
  action?: any;
  accountId?: string;
  accountName?: string;
  userId?: string;
  isActive: boolean;
}
